<mat-sidenav-container class="gas-sidenav-container">
    <mat-sidenav-content>
        <div class="floating-selects">
            <ng-container *ngIf="this.isImageAssetType; else videoBlock">
                <mat-form-field appearance="fill" class="select-field">
                    <mat-select
                        [disabled]="isGeneratingProcessGoingOn"
                        [value]="this.selectedImageModel"
                        (selectionChange)="onImageModelChange($event.value)">
                        <mat-option *ngFor="let m of imageModels" [value]="m">
                            {{ m.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>

            <ng-template #videoBlock>
                <mat-form-field appearance="fill" class="select-field">
                    <mat-select
                        [disabled]="isGeneratingProcessGoingOn"
                        [(value)]="this.selectedVideoModel"
                        (selectionChange)="onVideoModelChange($event.value)">
                        <mat-option *ngFor="let m of videoModels" [value]="m">
                            {{ m.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-template>

            <mat-form-field appearance="fill" class="select-field">
                <mat-select
                    [disabled]="isGeneratingProcessGoingOn"
                    [(value)]="selectedAspectRatio"
                    (selectionChange)="onAspectRatioChange($event.value)">
                    <mat-option *ngFor="let r of aspectRatios" [value]="r">
                        {{ r }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-slide-toggle
                *ngIf="this.isImageAssetType && this.toDisplayToIncludeLogo"
                class="logo-toggle"
                color="primary"
                [disabled]="isGeneratingProcessGoingOn"
                [(ngModel)]="includeLogo"
                (change)="onIncludeLogoChange($event)">
                Include logo
            </mat-slide-toggle>
        </div>
        <div class="main-section">
            <div class="set-mode-wrapper">
                <mat-button-toggle-group
                    [disabled]="isGeneratingProcessGoingOn"
                    [value]="currentViewMode"
                    (change)="setCurrentViewMode($event.value)"
                    class="set-mode">
                    <mat-button-toggle [disabled]="this.onEditImage" value="input"> Input</mat-button-toggle>
                    <mat-button-toggle value="preview" [disabled]="!isAbleToSeePreviewScreen">
                        Preview
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <h1 class="preview-heading" *ngIf="this.generatedImageUrl || this.generatedVideoUrl">
                {{ headerText }}
            </h1>
            <div *ngIf="currentViewMode === 'input'" class="to-generate">
                <div class="video-player-icon-container" *ngIf="!generatedImageUrl && !toDisplayAssetsLibrary">
                    <ng-lottie
                        class="video-player-icon"
                        containerClass="video-player-icon-container"
                        [options]="{
                            path: this.lottiePath,
                            loop: 1,
                        }"></ng-lottie>
                </div>

                <div class="use-asset" *ngIf="!toDisplayAssetsLibrary && !generatedImageUrl">
                    <div class="create-icon-img"></div>
                    <span> {{ promptCreateText }} </span>
                    <br /><br />
                    <span> You can use an image as {{ promptUseImageText }}. </span> <br />
                    <span
                        (drop)="handleFileDropAsync($event)"
                        (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)"
                        class="look-like-link clickable">
                        <label mat-raised-button (click)="fileInput.click()" class="look-like-link clickable">
                            upload image
                        </label>
                        <input #fileInput accept="image/*" type="file" (change)="onFileSelectAsync($event)" hidden />
                    </span>
                    or
                    <label (click)="setDisplayAssetLibrary(true)" class="look-like-link clickable">
                        choose an asset </label
                    >.
                </div>

                <div *ngIf="!toDisplayAssetsLibrary && generatedImageUrl">
                    <div class="image-preview">
                        <img [src]="generatedImageUrl" alt="Preview image" (load)="onImageLoad($event)" />
                    </div>
                </div>
                <div class="asset-library" *ngIf="toDisplayAssetsLibrary">
                    <div class="return">
                        <button mat-icon-button (click)="setDisplayAssetLibrary(false)">
                            <mat-icon>close</mat-icon>
                        </button>
                        <app-assets-main></app-assets-main>
                    </div>
                </div>

                <!--                <div class="form-section" *ngIf="showAdvancedOptions">-->
                <!--                    <label class="field-label">Suggested Prompts</label>-->
                <!--                    <mat-form-field style="width: 100%" appearance="outline">-->
                <!--                        <mat-select-->
                <!--                            placeholder="Choose a suggested prompt..."-->
                <!--                            (selectionChange)="onPromptSelect($event.value)">-->
                <!--                            <mat-option *ngFor="let p of suggestedPrompts" [value]="p.text">-->
                <!--                                {{ p.header }}-->
                <!--                            </mat-option>-->
                <!--                        </mat-select>-->
                <!--                    </mat-form-field>-->
                <!--                </div>-->
            </div>

            <div *ngIf="currentViewMode === 'preview'" class="preview">
                <div class="preview-content">
                    <ng-container *ngIf="isGeneratingProcessGoingOn">
                        <div class="video-placeholder animated-placeholder">
                            <h3>Generating...</h3>
                            <h5>This may take up to a couple of minutes to complete.</h5>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!isImageAssetType && generatedVideoUrl && toDisplayExtendVideo">
                        <button
                            *ngIf="this.generatedAsset.canExtendDuration"
                            (click)="isExtendingVideo = !isExtendingVideo">
                            Extend the video
                        </button>
                        <video [src]="generatedVideoUrl" controls></video>
                    </ng-container>

                    <ng-container *ngIf="this.isImageAssetType && generatedImageUrl">
                        <div class="image-preview">
                            <img [src]="generatedImageUrl" alt="Generated image" (load)="onImageLoad($event)" />
                        </div>
                    </ng-container>

                    <button
                        *ngIf="
                            (this.generatedImageUrl || this.generatedVideoUrl) &&
                            !isGeneratingProcessGoingOn &&
                            showUseButton
                        "
                        mat-raised-button
                        color="primary"
                        class="template-card__use-button"
                        (click)="onUseGeneratedAsset()">
                        Use it
                    </button>
                </div>
            </div>
            <div
                class="preview-actions"
                *ngIf="(generatedImageUrl || generatedVideoUrl) && !isGeneratingProcessGoingOn">
                <button mat-button class="action-btn" (click)="startNewChat()">
                    <mat-icon>add</mat-icon>
                    Start New
                </button>

                <ng-container>
                    <button
                        *ngIf="this.generatedImageUrl && toDisplayEditImageButton"
                        mat-button
                        class="action-btn"
                        (click)="startEditImage(false)">
                        <mat-icon>edit</mat-icon>
                        Edit Image
                    </button>
                    <button
                        *ngIf="!showUseButton && this.isImageAssetType && this.enableImageToVideo"
                        mat-raised-button
                        color="primary"
                        class="make-video-btn"
                        (click)="generateVideoFromImage()">
                        <mat-icon>movie</mat-icon>
                        Make it Video
                    </button>
                    <button
                        *ngIf="!this.isImageAssetType && this.currentViewMode === 'preview'"
                        mat-button
                        class="action-btn"
                        (click)="regenerateVideo()">
                        <mat-icon>edit</mat-icon>
                        Regenerate
                    </button>
                </ng-container>
            </div>
            <div
                *ngIf="!toDisplayAssetsLibrary"
                class="prompt-area"
                [class.disabled]="
                    this.isGeneratingProcessGoingOn || (this.currentViewMode === 'preview' && !this.isExtendingVideo)
                ">
                <div class="prompt-row">
                    <mat-form-field class="prompt-input">
                        <textarea
                            class="prompt-textarea"
                            (keydown.enter)="onPromptSubmit($event)"
                            (input)="onPromptInput($event)"
                            [(ngModel)]="prompt"
                            autocomplete="off"
                            cdkTextareaAutosize
                            matInput
                            [placeholder]="promptLabel"></textarea>

                        <div class="upload-button-wrapper" *ngIf="currentViewMode === 'input' && !referenceAssetId">
                            <label>
                                <button mat-button (click)="fileInput.click()">
                                    Upload
                                    <mat-icon>cloud_upload</mat-icon>
                                </button>
                                <input
                                    #fileInput
                                    accept="image/*"
                                    type="file"
                                    (change)="onFileSelectAsync($event)"
                                    hidden />
                            </label>
                        </div>

                        <button
                            mat-raised-button
                            color="primary"
                            class="generate-btn"
                            [disabled]="!isPromptValid"
                            (keydown.enter)="onGenerate()"
                            (click)="onGenerate()">
                            {{ buttonText }}
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
